import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { Img } from '@shared/Frontend/components/img'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { isMobileNumber, whatsappFriendlyPhone } from '@shared/Frontend/utils/phone'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'

export const ContactBlock: BlocksView['ContactBlock'] = (props) => {
  const {
    id,
    title,
    image,
    personName,
    personEmail,
    personFacebook,
    personFunction,
    personInstagram,
    personLinkedIn,
    personPhone,
    personTwitter,
    personWebsite,
  } = props
  const { inView, ref } = useInView({ threshold: 0.1 })

  const SubHeading = title ? 'h3' : 'h2'
  return (
    <section id={id} ref={ref} className={cn('block block--contact ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter">
        <BlockHeader {...props} />

        <div className="block__layout">
          <div className="block__content contact">
            <div className="contact__info">
              <SubHeading className="contact__name">{personName}</SubHeading>
              {personFunction && <p className="contact__description">{personFunction}</p>}
            </div>

            {(personEmail ||
              personWebsite ||
              personFacebook ||
              personLinkedIn ||
              personInstagram ||
              personTwitter ||
              personPhone) && (
              <ul className="contact__socials socials">
                {personEmail && <ContactSocialItem kind="Email" href={`mailto:${personEmail}`} label={personEmail} />}
                {personPhone && <ContactSocialItem kind="Phone" href={`tel:${personPhone}`} label={personPhone} />}
                {personWebsite && <ContactSocialItem kind="Website" href={personWebsite} />}
                {personFacebook && <ContactSocialItem kind="Facebook" href={personFacebook} />}
                {personLinkedIn && <ContactSocialItem kind="LinkedIn" href={personLinkedIn} />}
                {personInstagram && <ContactSocialItem kind="Instagram" href={personInstagram} />}
                {personTwitter && <ContactSocialItem kind="Twitter" href={personTwitter} />}
                {personPhone && isMobileNumber(personPhone) && (
                  <ContactSocialItem kind="WhatsApp" href={`https://wa.me/${whatsappFriendlyPhone(personPhone)}`} />
                )}
              </ul>
            )}

            <BlockActions {...props} datalayerCategory="contact_block" />
          </div>

          {image && (
            <div className="block__visual">
              <Img {...image} loading="lazy" className="block__image" width="500" height="500" />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

const ContactSocialItem = (props: {
  kind: 'Email' | 'Phone' | 'Website' | 'LinkedIn' | 'Facebook' | 'Twitter' | 'WhatsApp' | 'Instagram'
  href: string
  label?: string
}) => {
  return (
    <li className="socials__item">
      <a
        className="socials__clickable"
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          pushDatalayer({ category: 'contact_block', label: props.href, action: `${props.kind.toLowerCase()}_click` })
        }
      >
        <span className="socials__clickableLabel">{props.label || props.kind}</span>
      </a>
    </li>
  )
}
